import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {

  showBadge() {
    const favicon = document.head.querySelector('link[rel="icon"]') as HTMLLinkElement
    if (favicon) {
      favicon.href = 'logo-badge.svg'
    }
  }

  hideBadge() {
    const favicon = document.head.querySelector('link[rel="icon"]') as HTMLLinkElement
    if (favicon) {
      favicon.href = 'logo.svg'
    }
  }

}
